var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQuestionOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_838_46579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.53711 7.33301H7.90039C7.91113 6.06543 8.65234 5.07715 10.124 5.07715C11.2305 5.07715 12.2725 5.63574 12.2725 6.98926C12.2725 8.04199 11.6279 8.52539 10.6289 9.2666C9.46875 10.0938 8.59863 11.082 8.67383 12.6611L8.68457 13.4023H11.0264V12.8115C11.0264 11.6084 11.4883 11.2539 12.7344 10.3193C13.7656 9.55664 14.8506 8.68652 14.8506 6.86035C14.8506 4.27148 12.6699 3.02539 10.2529 3.02539C7.9541 3.02539 5.47266 4.14258 5.53711 7.33301ZM8.38379 16.7861C8.38379 17.6133 9.07129 18.2148 9.89844 18.2148C10.7256 18.2148 11.4023 17.6133 11.4023 16.7861C11.4023 15.959 10.7256 15.3574 9.89844 15.3574C9.07129 15.3574 8.38379 15.959 8.38379 16.7861Z",
    fill: "url(#paint0_linear_838_46579)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_838_46579",
    x1: 6.2375,
    y1: 1.875,
    x2: 14.685,
    y2: 2.19195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD3C2F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_838_46579"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.046875 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestionOrange);
export default __webpack_public_path__ + "static/media/icon_question_orange.262d1f99901b96fe2778c1f61aae6def.svg";
export { ForwardRef as ReactComponent };